import useSWR from "swr";
import { Icd10Codes } from "../../../messages";
import { withDefault } from "../../../utils/withDefault";

export function useSearchIcdCodes(
  fetcher: (searchValue: string) => Promise<Icd10Codes>,
  searchValue: string | undefined
) {
  const { data, error } = useSWR(withDefault(searchValue, ""), fetcher);

  return {
    results: data,
    isLoading: data === undefined && error === undefined,
    error: error,
  };
}
